// extracted by mini-css-extract-plugin
module.exports = {"page":"borswer-not-support_page__1Nu7i"};